export const discountList = [
  { id: 0, title: "Не предоставлена", value: "No" },
  { id: 1, title: "На документ", value: "OnDocument" },
  { id: 2, title: "На отдельные позиции", value: "OnPosition" }
];

export const taxList = [
  { id: 0, title: "В сумме", value: "InSumm" },
  { id: 1, title: "Сверху", value: "OnTopSumm" }
];

export const SeachFieldEnum = {
  ORDER: 'nomenclatureOrder',
  SHIPMENT: 'nomenclatureShipment',
  INVOICE: 'nomenclatureInvoice',
  COMING: 'nomenclatureComing',
  RECORDING: 'nomenclatureRecording',
  WRITEDOWN: 'nomenclatureWriteDown',
  MOVE: 'nomenclatureMove',
  SPECIFICATION: 'nomenclatureSpecif',
  NOMENCLATURE: 'nomenclatureId',
  INVENTORY: 'nomenclatureId',
  ITEM: 'itemId',
  NOMENCLATURE: 'nomenclatureId',
  ID: 'id',
} 